import { pick } from 'ramda';
import { useCallback } from 'react';
import { getURLParam } from '@core/js/utils/url.util';
import { useAppSelector, useDeviceSelector } from '@core/js/store/hooks';

import * as server from '@core/js/hooks/auth/hooks/useRegister/server';

export const useRegister = () => {
    const { clientPlatform, uaOrigin } = useDeviceSelector(pick(['clientPlatform', 'uaOrigin']));
    const { casinoName, clientSkin, clientVersion, clientType: appClientType } = useAppSelector(pick(['casinoName', 'clientSkin', 'clientVersion', 'clientType']));
	const clientType = getURLParam(location.search, 'clientType') || appClientType;

    return useCallback(async ({
        addressDetails,
        contactAddress,
        dataMap,
        depositLimits,
        betLimits,
        lossLimits,
        lossLimitsAction,
        contactPreferences,
        tags,
        token,
        blackbox,
        betLimitsAction
    }) => {
        const {
            data: {
                playerCode,
                userId,
                actions
            }
        } = await server.createPlayerInfo({
            addressDetails,
            blackbox,
            casinoName,
            contactAddress,
            dataMap: {
                ...casinoName && { casinoName },
                ...clientSkin && { clientSkin },
                ...clientType && { clientType },
                ...clientPlatform && { clientPlatform },
                ...clientVersion && { signupClientVersion: clientVersion },
                ...uaOrigin && { signupUserAgent: uaOrigin },
                ...dataMap
            },
            token
        });

        const { userName, email } = dataMap;

        if (depositLimits || betLimits || lossLimits || betLimitsAction || lossLimitsAction || contactPreferences || tags) {
            await server.sendBatchRequest({
                authParameters: {
                    casinoName, ...userName && { playerName: userName }, ...email && { email }
                },
                depositLimits,
                betLimits,
                lossLimits,
                betLimitsAction,
                lossLimitsAction,
                contactPreferences,
                tags
            });
        }

        return {
            playerCode,
            userId,
            actions
        };
    }, [uaOrigin, clientType, casinoName, clientPlatform, clientVersion, clientSkin]);
};
